import React, { Component } from 'react';
import { ListLayout } from '../containers/Layout';
import { InputSelect, InputSelectMagasin } from '../../../../commonModules/interface/form-input-inline';
import { TableRow, TableCell, Button, TableHead, TableBody, Box, IconButton, Tab, Tabs, Tooltip, MenuItem, Menu, ListItemIcon, ListItemText } from '@material-ui/core';
import { AddRounded, CloseRounded, CheckBoxRounded, CloudDownloadRounded, EditRounded, MoreVertRounded, SendRounded } from '@material-ui/icons';
import TableFooterPagination from '../../../../commonModules/interface/TableFooterPagination';
import DeleteDialogConfirm from '../../../../commonModules/interface/DeleteDialogConfirm';
import StockExtractButton from '../StockExtractButton';
import { toast } from 'react-toastify';

class ListArrivage extends Component {
    state = { 
        view : "arrivage",
        single:{
            product_id: "",
            shop_id: ""
        },
        singleProd:{},
        singleShop:{},
        singleArrivage:{
            purchase:{},
            shop:{},
        },

        breadcrumb: "",

        deletePopUp: false,
        toDelete:{
            id:""
        },
      
        search:"",
        received: "ALL",
        filteredList:[],
        reload : false,

        selectShop:"",
        selectShopDisplay:{
            value:"",
            label:"Tous les Magasins",
        },

        anchorEl: null, 
        openMenu: "", 

    }

    componentDidMount = () => {
        console.log("MOUNTING ListArrivages ");
        this.filterList("")
    }

    createArrivageList(){// purchase list tr
        const { SHOPS, currentPage, rowsPerPage } = this.props
        const {anchorEl, openMenu } = this.state;
        
        return this.state.filteredList.slice(currentPage * rowsPerPage, currentPage * rowsPerPage + rowsPerPage).map(purchase => {  
            let shop = SHOPS[purchase.shop_id]
            return (        
                <TableRow key={purchase.id}>
                    <TableCell>{(new Date(purchase.date)).toLocaleString('fr-FR')}</TableCell>
                    <TableCell>{(new Date(purchase.arrival_date)).toLocaleDateString('fr-FR')}</TableCell>
                    <TableCell>
                        <a href="#" onClick={
                            () => this.props.handleSingleShop(shop)
                            }> {shop.name}
                        </a>
                    </TableCell>     
                    <TableCell>
                        {purchase.received ? "Reçu" : "En attente"}
                    </TableCell>                   
                    <TableCell>
                        <IconButton color="secondary" onClick={
                            () => this.props.handleSingleArrivage(purchase, shop)
                        }
                        > 
                            <AddRounded />
                        </IconButton>
                    </TableCell>                                
                    <TableCell>
                        <>
                            {!purchase.received &&
                                <IconButton 
                                    aria-controls={`option-menu${purchase.id}`} 
                                    aria-haspopup="true"
                                    onClick={(event) => this.setState({ anchorEl: event.currentTarget, openMenu : purchase.id}) }>
                                    <MoreVertRounded />
                                </IconButton>
                            }
                            <Menu
                                MenuListProps={{
                                'aria-labelledby': 'basic-button',
                                }}
                                id={`option-menu${purchase.id}`}
                                anchorEl={anchorEl}   
                                                                            
                                anchorOrigin={{
                                    vertical: 'bottom',
                                    horizontal: 'right',
                                }}
                                transformOrigin={{
                                    vertical: 'top',
                                    horizontal: 'right',
                                }}
                                open={ openMenu === purchase.id}
                                onClose={() => this.setState({ openMenu: "", anchorEl: null})}
                            >                                
                                <MenuItem onClick={ () => this.props.handleUpdateArrivage(purchase, shop) }>
                                    Modifier
                                </MenuItem>
                                <MenuItem onClick={ () => this.props.handleCompleteArrivage(purchase, shop) }>
                                    Valider la réception
                                </MenuItem>
                                <MenuItem onClick={ () => this.setState({ toDelete: purchase, deletePopUp : true })} >
                                    Supprimer
                                </MenuItem>                                   
                            </Menu>
                        </>
                    </TableCell>
                </TableRow>
            )
        })
    }
    createDemandeList(){// purchase list tr
        const { SHOPS, currentPage, rowsPerPage } = this.props
        
        return this.state.filteredList.slice(currentPage * rowsPerPage, currentPage * rowsPerPage + rowsPerPage).map(purchase => {  
            let shop = SHOPS[purchase.shop_id]
            return (        
                <TableRow key={purchase.id}>
                    <TableCell>{(new Date(purchase.date)).toLocaleString('fr-FR')}</TableCell>
                    <TableCell>{(new Date(purchase.arrival_date)).toLocaleDateString('fr-FR')}</TableCell>
                    <TableCell>
                        <a href="#" onClick={
                            () => this.props.handleSingleShop(shop)
                            }> {shop.name}
                        </a>
                    </TableCell>     
                                    
                    <TableCell>
                        <IconButton color="secondary" onClick={
                            () => this.props.handleSingleArrivage(purchase, shop)
                        }
                        > 
                            <AddRounded />
                        </IconButton>
                    </TableCell>                                
                    <TableCell>
                        <Tooltip placement="top" title="Supprimer">
                            <IconButton 
                                onClick={ () => 
                                    this.setState({
                                        toDelete: purchase,
                                        deletePopUpD : true
                                    })
                                }
                                >
                                <CloseRounded color="error"/>
                            </IconButton>
                        </Tooltip>
                    </TableCell>
                </TableRow>
            )
        })
    }
    createShopList = () => {
        const list = [{value:"", label:"Tous les Magasins"}]
        const { SHOPS} = this.props
        if( SHOPS ){
            Object.values(SHOPS).map( shop => { 
                list.push (       
                    {value:shop.id, label:shop.name} 
                )
            })
        } 
        return list
    }
    
    shopFilter(selected){
        const { ARRIVAGES } = this.props
        let filteredShop = Object.values(ARRIVAGES).filter( purchase => purchase.shop_id === selected)
           
        console.log({filteredShop});

        return filteredShop
    }
            
    filterList(selectedShop = this.state.selectShop, received = this.state.received, view = this.state.view){
        console.log({selectedShop, received});
        let list = Object.values(this.props.ARRIVAGES)
        if (view === "demandes") {
            list = Object.values(this.props.DEMANDS)
        }
        let filteredList = selectedShop ? this.shopFilter(selectedShop) : list
        if (typeof received == "boolean"){
            filteredList = filteredList.filter(item => item.received == received)
        }
        this.setState({
            filteredList,
            reload:!this.state.reload,
            view,
        })
    }

    deleteArrivage = async (comments) => {
        let data = {
            op_id: this.state.toDelete.id,
            comments
        }
        await this.props.deleteArrivage(data)
            
        if(this.props.STATE.arrivages.error){
            console.log("[ERROR] delete purchase", this.props.STATE.arrivages.error); 
            toast.error(  this.props.STATE.arrivages.error)
            // this.props.notif( "danger", "Un Problème est survenu")
        } else {
            toast.success("Arrivage supprimé avec succès")
            this.setState({
                deletePopUp:false,
                toDelete:{id: ""},
                anchorEl: null, 
                openMenu: "", 
        
            })
        }                             
    }
    deleteDemand = async (comments) => {
        console.log("[DELETE],deleteDemand",comments)
        let data = {
            op_id: this.state.toDelete.id,
            comments
        }
        try{
            const resp = await this.props.deleteDemand(data)
            console.log("fetched");
            toast.success( "Demande supprimée avec succès")
            this.setState({
                deletePopUpD:false,
                toDelete:{id: ""},
                anchorEl: null, 
                openMenu: "", 
        
            })
        }catch(err){
            console.log("ERROR", err);
            this.setState({
                    sending: false,
                })
            toast.error("[ERROR],"+err.message)
        }                         
    }
    
    render() {
        let shops = this.createShopList()
     
        console.log('====================================');
        console.log("[PAGE of ITEMS]", this.props.pageOfItems);
        console.log('====================================');
    
        return (
            <Box>
                {this.state.deletePopUp &&
                    <DeleteDialogConfirm
                        title={"l'arrivage n°" + this.state.toDelete.id}
                        handleSubmit={this.deleteArrivage}
                        block={true}
                        close={() => this.setState({ deletePopUp: false })}
                    />
                }
                {this.state.deletePopUpD &&
                    <DeleteDialogConfirm
                        title={"la demande" + this.state.toDelete.id}
                        handleSubmit={this.deleteDemand}
                        block={true}
                        close={() => this.setState({ deletePopUpD: false })}
                    />
                }
                
                <Box style={{display: "flex", justifyContent:"space-between"}}>
                    <InputSelectMagasin
                        options={shops}
                        value={this.state.selectShopDisplay}
                        label="Sélectionner un Magasin"
                        onChange={(option) => {
                            this.setState({ 
                                selectShopDisplay: option, 
                                selectShop:option.value
                            }); 
                            this.filterList(option.value, undefined)}
                        }
                        maxWidth
                    /> 
                   
                    <StockExtractButton
                        icon={<CloudDownloadRounded />}
                        color="secondary"
                        title={this.state.view !== "arrivage" ? "Extract demandes" : "Extract Arrivages" }
                        extract={this.state.view !== "arrivage" ? "demands": "arrivages"}
                    />
                    
                </Box>
                <Tabs 
                    value={this.state.view} 
                    onChange={(e, view) => this.filterList(undefined, undefined, view) }
                    indicatorColor="primary"
                    textColor="primary"
                    variant="fullWidth"
                >
                    <Tab value="arrivage" label="Arrivages" />
                    <Tab value= "demandes" label="Demandes" />
                </Tabs>
                <ListLayout>
                    <TableHead>
                        <TableRow>
                            <TableCell>Date</TableCell>
                            <TableCell>{this.state.view == "arrivage" ? "Date d'arrivée" : "Date souhaitée"}</TableCell>
                            <TableCell>Shop</TableCell>
                            {this.state.view == "arrivage" && <TableCell>Etat</TableCell>}
                            <TableCell>Détails</TableCell>
                            <TableCell>Options</TableCell>
                        </TableRow>
                    </TableHead>
                    {this.state.view == "arrivage" ?
                    <TableBody>
                        { this.state.filteredList.length > 0 && this.createArrivageList() }
                        { this.state.filteredList.length === 0  && 
                            <TableRow>
                                <TableCell colSpan={6}>
                                    <div className="text-center">
                                        Cliquez sur <Button color="primary" className="text-right"
                                        
                                        onClick={ () => this.props.handleOpenForm("new", "Nouvel Arrivage") }
                                        >Nouveau</Button>  pour entrer un nouvel Arrivage
                                    </div>
                                </TableCell>
                            </TableRow>
                        }
                    </TableBody>
                    :
                    <TableBody>
                        { this.state.filteredList.length > 0 && this.createDemandeList() }
                        { this.state.filteredList.length === 0  && 
                            <TableRow>
                                <TableCell colSpan={6}>
                                    <div className="text-center">
                                        Cliquez sur <Button color="primary" className="text-right"
                                        onClick={ () => this.props.handleOpenForm("newDemand", "Nouvelle demande d'achat") }
                                        >Nouveau</Button> pour entrer une nouvelle Demande d'achat
                                    </div>
                                </TableCell>
                            </TableRow>
                        }
                    </TableBody>
                    }
                    { this.state.filteredList.length > 0 && 
                        <TableFooterPagination 
                            colSpan={6}
                            items={this.state.filteredList}
                            onChangePage={this.props.onChangePage}
                            initialPage={this.props.currentPage || 0}
                        />
                    }
                </ListLayout>                     
            </Box>
        );
    }
}

export default ListArrivage;